"use strict";

var _regeneratorRuntime = require("/builds/sites/europa-fm-pwa/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _functions = require("../utils/functions");

var _constants = require("../utils/constants");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var _default = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var _document, title, referrer, _document$location, hostname, pathname, parsePath, url, regex, campaña;

  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _document = document, title = _document.title, referrer = _document.referrer, _document$location = _document.location;
          _document$location = _document$location === void 0 ? {} : _document$location;
          hostname = _document$location.hostname, pathname = _document$location.pathname;
          parsePath = hostname + (pathname !== '/' ? pathname : '');
          url = hostname + pathname;
          regex = ':';
          _context.next = 8;
          return (0, _functions.getCampaignParams)();

        case 8:
          campaña = _context.sent;
          return _context.abrupt("return", {
            broadlogId: undefined,
            campaignId: undefined,
            campaña: campaña,
            dominio: hostname,
            embebido: _constants.NO,
            pageName: (0, _functions.getUrlFormated)(parsePath).replace('www.', ''),
            referente: referrer || undefined,
            subseccionNivel1: (0, _functions.getPath)(url, regex, 1),
            subseccionNivel2: (0, _functions.getPath)(url, regex, 2),
            subseccionNivel3: (0, _functions.getPath)(url, regex, 3),
            subseccionNivel4: (0, _functions.getPath)(url, regex, 4),
            titulo: title,
            url: url
          });

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}));

exports["default"] = _default;